<script>import { createEventForwarder, useActions } from '../../internal';
import { get_current_component } from 'svelte/internal';
import { portal } from '@svelteuidev/composables';
export let use = [], element = undefined, className = '', target = 'body', position = 'relative', zIndex = 1;
export { className as class };
/** An action that forwards inner dom node events from parent component */
const forwardEvents = createEventForwarder(get_current_component());
</script>

<div
	bind:this={element}
	use:useActions={use}
	use:forwardEvents
	use:portal={target}
	class={className}
	hidden
	style="position: {position}; zIndex: {zIndex};"
>
	<slot />
</div>
